import hipaaImage from "assets/images/hipaa.svg";
import styled from "styled-components";

const FooterStyled = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;

  height: 64px;
  padding: 12px 32px !important;
  box-sizing: border-box;

  background-color: var(--color-white);
  border-top: 1px solid var(--color-black-1);

  @media (min-width: 1024px) {
    padding-left: 96px;
    padding-right: 96px;
  }
`;

const ClearLogo = styled.img`
  max-height: 36px;
  object-fit: contain;
`;

export function Footer(): JSX.Element {
  return (
    <FooterStyled className="w-full p-3">
      <ClearLogo src="/logo_footer_gray.png" alt="Clear Health Logo" />
      <ClearLogo src={hipaaImage as string} alt="Hipaa Compliant" />
    </FooterStyled>
  );
}
